export default {"src":"/_next/static/media/facebook-icon.380fa5f3.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};